import { observer } from 'mobx-react';
import React, { useContext, useState } from 'react';
import * as S from './Persona.style';
import { RootStoreContext } from '../../App';
import PersonaModal from './personaModal/PersonaModal';

export const Persona = observer(() => {
	const { mqttStore, likuStore } = useContext(RootStoreContext);
	const [selectedPersona, setSelectedPersona] = useState(null);

	const personas = [
		{
			key: '소방관 리쿠',
			desc: '불이 나면 제일 먼저 달려가는 용감한 소방관',
		},
		{
			key: '경찰관 리쿠',
			desc: '언제나 모두를 지켜주는 든든한 경찰관',
		},
		// {
		// 	key: '의사 리쿠',
		// 	desc: '딱 보면 척! 아픈 곳을 고쳐주는 멋진 의사',
		// },
		{
			key: '간호사 리쿠',
			desc: '다정하게 보살펴주는 친절한 간호사',
		},
		{
			key: '환경지킴이 리쿠',
			desc: '지구를 지켜주는 고마운 환경 지킴이',
		},
		{
			key: '천문학자 리쿠',
			desc: '밤 하늘을 보며 별을 연구하는 똑똑한 천문학자',
		},
		{
			key: '요리사 리쿠',
			desc: '뚝딱뚝딱! 맛있고, 건강함을 만드는 행복 요리사',
		},
		{
			key: '선생님 리쿠',
			desc: '아이들의 궁금증을 모두 해결해 주는 똑똑! 선생님',
		},
		{ key: '리쿠', desc: '언제나 함께하는 우리 친구 리쿠' },
	];

	const handlePersonaClick = (persona) => {
		setSelectedPersona(persona);
	};

	const handleCloseModal = () => {
		setSelectedPersona(null);
	};

	const handleApplyPersona = (personaKey) => {
		const likuVer = +likuStore?.thisLiku?.version?.likuVer;
		console.log('likuVer', likuVer, typeof likuVer, likuVer < 4.27);
		if (mqttStore?.isConnected) {
			mqttStore?.likuMqtt?.setPersona(personaKey);
			setSelectedPersona(null);
		} else if (likuVer < 4.27) {
			alert(
				'리쿠 버전이 4.27 이상이어야 합니다. 업데이트 후 다시 시도해 주세요.',
			);
		} else {
			alert('리쿠가 연결되지 않았습니다. 리쿠를 먼저 연결해 주세요.');
		}
	};

	const handleFeedbackClick = () => {
		window.open('https://forms.gle/NxCxxmQmbmjBt3dA6', '_blank');
	};

	return (
		<S.Container>
			<S.Title>리쿠 캐릭터 설정</S.Title>
			<S.SubTitle>
				오늘 리쿠는 어떤 모습으로 변신하면 좋을까요? 리쿠 캐릭터를 선택해서
				대화해 보세요.
			</S.SubTitle>
			<S.Caption>
				* 지금은 시범 운영 중입니다. 선생님들의 의견을 반영해 정식 버전을 곧
				선보이겠습니다.
				<S.FeedbackButton onClick={handleFeedbackClick}>
					의견 제출하기
					<span role='img' aria-label='feedback'>
						✍️
					</span>
				</S.FeedbackButton>
			</S.Caption>

			<S.ButtonContainer>
				{personas.map((persona, index) => (
					<S.PersonaButton
						key={index}
						onClick={() => handlePersonaClick(persona)}>
						<S.PersonaName>
							{persona.key === '리쿠' ? '리쿠 캐릭터로 돌아가기' : persona.key}
						</S.PersonaName>
						<S.PersonaDesc>{persona.desc}</S.PersonaDesc>
					</S.PersonaButton>
				))}
			</S.ButtonContainer>

			<S.InfoContainer>
				<S.SubTitle>사용방법</S.SubTitle>
				<S.Guide>1. 먼저 리쿠의 전원을 켠 후, 포털에 연결해 주세요.</S.Guide>
				<S.Guide>
					2. 체험하고 싶은{' '}
					<span style={{ fontWeight: 'bold' }}>리쿠 캐릭터</span>를 선택해
					주세요. (예: 소방관 리쿠, 경찰관 리쿠 등)
				</S.Guide>
				{/* eslint-disable-next-line react/no-unescaped-entities */}
				<S.Guide>
					3. 선택한 캐릭터의 역할과 내용을 확인한 뒤,{' '}
					<span style={{ fontWeight: 'bold' }}>적용하기</span> 버튼을 눌러
					주세요.
				</S.Guide>
				<S.Guide>
					4. 리쿠와 자유롭게 대화해 보세요. 캐릭터에 대한 정보를 참고해 질문해
					보는 것도 좋아요!
				</S.Guide>
				<S.Guide>
					5. 다시 리쿠로 돌아가고 싶을 때는{' '}
					<span style={{ fontWeight: 'bold' }}>리쿠 캐릭터로 돌아가기 </span>
					버튼을 누르거나 리쿠를 껐다가 다시 켜 주세요.
				</S.Guide>
				<br />
				<br />
				<S.SubTitle>주의사항</S.SubTitle>
				<S.Guide>- 리쿠의 전원을 종료하면 리쿠 캐릭터는 초기화 됩니다.</S.Guide>
				<S.Guide>
					- 캐릭터 설정은{' '}
					<span style={{ fontWeight: 'bold' }}>포털과 연결된 리쿠에서만</span>
					사용할 수 있습니다.
				</S.Guide>
			</S.InfoContainer>
			{selectedPersona && (
				<PersonaModal
					persona={selectedPersona}
					onClose={handleCloseModal}
					onApply={handleApplyPersona}
				/>
			)}
		</S.Container>
	);
});

export default Persona;
